import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import VehicleContext, {
  useGetIsWIPVehicle,
  useGetVehicleDetails
} from '~/context/vdp/VehicleContext';
import fetchWhyBuyData from '~/services/vdp/fetchWhyBuyData';
import { generateErrorLogger } from '~/utilities/loggers';
import useShowVaultWhyBuyContent from '../useHasVaultWhyBuyData';

export default function useGetWhyBuyData() {
  const vaultWhyBuyContentExists = useShowVaultWhyBuyContent();
  const isWIPVehicle = useGetIsWIPVehicle();
  const { kbbVehicleId = '' } = useGetVehicleDetails();
  const {
    ymmtWhyBuy: { setData, setError, setLoaded, setLoading }
  } = useContext(VehicleContext);

  useEffectWithController(
    controller => {
      if (!kbbVehicleId || vaultWhyBuyContentExists || isWIPVehicle) {
        setLoaded();

        return;
      }

      setLoading();

      fetchWhyBuyData(kbbVehicleId, controller)
        .then(setData)
        .catch(
          generateErrorLogger(
            'Get Ymmt Why Buy',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      isWIPVehicle,
      kbbVehicleId,
      setData,
      setError,
      setLoaded,
      setLoading,
      vaultWhyBuyContentExists
    ]
  );
}
